import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/(main)/[...doc]/EmbeddedContrastTool.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/(main)/[...doc]/EmbeddedGuidelinesList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/(main)/[...doc]/EmbeddedPersonas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/(main)/[...doc]/MarkCompletedButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AltDecisionTree/AltDecisionTree.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prose"] */ "/app/src/components/ArticleAccessibilityMenu/ArticleAccessibilityTextSize.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Button/IconButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EmojiText/EmojiText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MDX/CheckList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/MDX/H1.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MDX/Iframe.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/MDX/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MDX/MultipleChoice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MDX/Personas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MDX/SingleTip.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NewsOverview/NewsOverview.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Section/Section.module.sass");
